import SearchHead from "components/searchHead";
import { SEARCH_ID_FORM_ROOM_PRODUCT } from "components/constent";
import { useTranslation } from "react-i18next";
import SearchForm from "./searchForm";
import RoomProductList from "./list";
import useModalStore from "store/modal";
import ProductCreate from "./create";
import {
  CreatePrudoctParamProvider,
  ProductFilterProvider,
  ProductParamsProvider,
} from "./context";

export default function RoomProductPage() {
  const { t } = useTranslation();
  const onSetModal = useModalStore((state) => state.onSetModal);

  const onCreate = () => {
    onSetModal({
      title: t("lbl_rm_create"),
      isOpen: true,
      styles: "w-full overflow-visible",
      inner: (
        <CreatePrudoctParamProvider>
          <ProductCreate />
        </CreatePrudoctParamProvider>
      ),
    });
  };

  return (
    <>
      <SearchHead
        title={t("sub_ttl_rmpd_detail")}
        formId={SEARCH_ID_FORM_ROOM_PRODUCT}
        isCreate
        onClick={onCreate}
      />
      <ProductParamsProvider>
        <ProductFilterProvider>
          <SearchForm />
        </ProductFilterProvider>
        <RoomProductList />
      </ProductParamsProvider>
    </>
  );
}
